import React from 'react';
import { Flex, Text, Box } from '../components';
import { humanReadableDateString } from '../../../assets/js/utils.js';

class ViewResult extends React.Component {
  render() {
    const { wotc_employee: wotcEmployee } = this.props.action;
    const {
      f8850_url: f8850Url,
      iframe_filled_at: submittedAt,
    } = wotcEmployee;

    const dateText = humanReadableDateString(submittedAt);

    return (
      <Flex column>
        <Flex column style={{ width: '368px', margin: 'auto' }}>
          <Flex mb={20}>
            <Text fontSize="22px" bold>{this.props.title}</Text>
          </Flex>
          <Flex alignItems="center">
            <Text>
              {name}
              {' '}
              submitted at
              {' '}
              {dateText}
            </Text>
            <Flex ml={2}>
              <a href={f8850Url} target="_blank" rel="noopener noreferrer">
                View on WOTC.com
              </a>
              <Box ml={1} />
            </Flex>
          </Flex>
        </Flex>
      </Flex>
    );
  }
}

export default ViewResult;
